































































































































































































































































































































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import {
  AiMonthReportSetting,
  DefaultAiMonthReportSetting,
  AiMonthReportAiSet,
  DefaultAiMonthReportAiSet,
  DefaultPromptTemplate,
} from "#/model/admin/index";
import { ListPromptTemplate } from "@/views/aimonthreport/types";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import AiSetEditDialog from "@/components/aimonthreport/AiSetEditDialog.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import RulesMixin from "#/mixins/rulesMixin";
import Sortable from "sortablejs";

@Component({
  components: {
    AppAuthButton,
    AiSetEditDialog
  },
})
/** 月次報告書自動作成管理 表示設定 */
export default class ViewSet extends Mixins(AxiosMixin, UtilMixin, RulesMixin) {
  /** 変数 */

  /** AI自動作成設定 */
  private setting: AiMonthReportSetting = DefaultAiMonthReportSetting();

  /** 登録済みプロンプトテンプレート */
  private promptTemplates: ListPromptTemplate[] = [];

  /** AI選択リスト追加用 */
  private addingAiSet: AiMonthReportAiSet = DefaultAiMonthReportAiSet();

  /** 詳細表示中AI選択リスト */
  private showingAiSet: AiMonthReportAiSet | null = null;

  /** AI選択リスト */
  private aiSets: AiMonthReportAiSet[] = [];

  /** AI選択リストデータテーブル用ヘッダー */
  private headers = [
    {
      text: "",
      value: "actions",
      filterable: false,
      sortable: false,
      align: "end",
      width: "240px",
    },
    {
      text: "表示",
      align: "start",
      value: "is_show",
      filterable: false,
      sortable: false,
      width: "80px",
    },
    {
      text: "有効",
      align: "start",
      value: "is_valid",
      filterable: false,
      sortable: false,
      width: "80px",
    },
    {
      text: "表示名",
      align: "start",
      value: "name",
      width: "240px",
      filterable: false,
      sortable: false,
    },
    {
      text: "本誌プロンプトテンプレート名",
      align: "start",
      value: "prompt_template_name",
      filterable: false,
      sortable: false,
      width: "240px",
    },
    {
      text: "本誌表現修正プロンプトテンプレート名",
      align: "start",
      value: "modify_main_expression_prompt_template_name",
      filterable: false,
      sortable: false,
      width: "260px",
    },
    {
      text: "別添プロンプトテンプレート名",
      align: "start",
      value: "betten_prompt_template_name",
      filterable: false,
      sortable: false,
      width: "240px",
    },
    {
      text: "別添表現修正プロンプトテンプレート名",
      align: "start",
      value: "modify_betten_expression_prompt_template_name",
      filterable: false,
      sortable: false,
      width: "260px",
    },
  ];

  /** Sortableオブジェクト */
  private sortable?: Sortable = undefined;

  /** AI選択リスト編集ダイアログ */
  private isEditDialog = false;

  /** getter */

  /** プロンプトテンプレート選択肢 */
  private get PromptTemplateChoice(): ListPromptTemplate[] {
    return [
      {
        id: 0,
        name: "未選択",
        comment: "",
        llm_type_name: "",
        model_name: "",
        editor_admin_name: "",
        created_at: "",
        updated_at: "",
      },
      ...this.promptTemplates,
    ];
  }

  /** 関数 */

  created() {
    this.fetch();
    this.fetchSetting();
  }

  mounted() {
    const elmSortList = document.querySelector(
      `.p-aiset-sort__list tbody`
    ) as HTMLElement;

    this.sortable = new Sortable(elmSortList, {
      animation: 100,
      ghostClass: "ghost",
      onEnd: (e) => {
        if (e.oldIndex !== undefined && e.newIndex !== undefined) {
          const rowSelected = this.aiSets.splice(e.oldIndex, 1)[0];
          this.aiSets.splice(e.newIndex, 0, rowSelected);
        }
      },
    });
  }

  /** 取得 */
  private fetch() {
    this.postJsonCheck(
      window.base_url + "/api/admin/aimonthreport/prompts/get",
      {},
      async (res) => {
        this.promptTemplates = res.data.prompt_templates;
      }
    );
  }

  /** 自動作成設定取得 */
  private fetchSetting() {
    this.postJsonCheck(
      window.base_url + "/api/admin/aimonthreport/setting/get",
      {},
      async (res) => {
        this.setting = res.data.ai_month_report_setting;
        this.aiSets = res.data.ai_sets;
      }
    );
  }

  /** 保存 */
  private async save() {
    if (this.aiSets.findIndex((aiSet) => aiSet.is_valid == 1) === -1) {
      await this.$openAlert("「有効」な設定を必ず1つ追加してください。");
      return;
    }

    if (this.setting.is_use_ai_set == 1 && this.aiSets.findIndex((aiSet) => aiSet.is_show == 1 && aiSet.is_valid == 1) === -1) {
      await this.$openAlert("AI選択機能を利用する場合は「表示」かつ「有効」な設定を必ず1つ追加してください。");
      return;
    }

    if (!(await this.$openConfirm("保存しますか？"))) {
      return;
    }

    this.postJsonCheck(
      window.base_url + "/api/admin/aimonthreport/setting/save",
      { ai_month_report_setting: this.setting, ai_sets: this.aiSets },
      async () => {
        this.fetch();
        this.fetchSetting();
        this.$openAlert("保存に成功しました。");
      }
    );
  }

  /** 追加 */
  private addAiSet() {
    if (this.addingAiSet.id == 0) {
      this.aiSets.push(this.addingAiSet);
    } else {
      const findIndex = this.aiSets.findIndex((aiSet) => aiSet.id == this.addingAiSet.id)
      this.aiSets.splice(findIndex, 1, this.addingAiSet);
    }
    this.addingAiSet = { ...DefaultAiMonthReportAiSet() };
    this.isEditDialog = false;
    this.assignSortNo();
  }

  /** 削除 */
  private async removeAiSet(item: AiMonthReportAiSet, index: number) {
    if (!(await this.$openConfirm("削除しますか？"))) {
      return;
    }
    this.aiSets.splice(index, 1);
    this.assignSortNo();
  }

  private assignSortNo() {
    this.aiSets.map((aiSet, idx) => {
      aiSet.sort_no = idx + 1;
    })
  }

  /** 対応プロンプトテンプレート情報取得 */
  private getPromptTemplate(id: number) {
    const p = this.promptTemplates.find((pt) => pt.id == id);
    return p === undefined ? DefaultPromptTemplate() : p;
  }

  private showUp(item: AiMonthReportAiSet): void {
    this.showingAiSet = { ...item };
  }

  private showDown(): void {
    this.showingAiSet = null;
  }

  private openEditDialog(): void {
    this.addingAiSet = { ...DefaultAiMonthReportAiSet() };
    this.isEditDialog = true;
  }

  private openEditDialogInEdit(aiSet: AiMonthReportAiSet): void {
    this.addingAiSet = {...aiSet};
    this.isEditDialog = true;
  }

  private cancelDialog(): void {
    this.addingAiSet = { ...DefaultAiMonthReportAiSet() };
    this.isEditDialog = false;
  }

  /** プロンプトテンプレート一覧画面へ遷移 */
  private moveToPromptTemplateListPage() {
    this.$router.push({
      path: "/ai-monthreport/prompt/list",
    });
  }
}
